export default __webpack_public_path__ + "static/media/picking.a3dfc4df.svg";